<template>
    <component :is="wrapperTag" v-if="scopevalue" :class="[(!!scopefield.configuration.container_width ? 'sm'+scopefield.configuration.container_width+'' : ''), (table ? 'px-0' : 'xs12' )]">
		<transition>
			<div class="os-field-container" v-show="visible" :class="[{ 'os-readonly-field' : scopefield.configuration.read_only }, {'fill-height' : !table }]">
				<div v-if="!editDisabled && viewform && inlineEdit && scopefield.type !== 'status'" class="os-action-btns">
					<v-slide-x-reverse-transition mode="out-in">
						<div :key="'transition-'+editing">
							<template v-if="!editing">
								<v-btn v-if="!scopefield.configuration.read_only" color="info" text icon class="right ma-0 os-hover-btn" :class="{'os-touch-device' : touchdevice}" @click.stop="editing = true;"><v-icon>mdi-circle-edit-outline</v-icon></v-btn>
							</template>
							<template v-else>
								<v-btn color="success" text icon class="ma-0" @click.stop="saveEdit" v-if="inlineSave"><v-icon>mdi-check-outline</v-icon></v-btn>
								<v-btn color="error" text icon class="ma-0" @click.stop="cancelEdit"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
							</template>
						</div>
					</v-slide-x-reverse-transition>
				</div>

				<div v-if="editDisabled || (viewform && !editing && scopefield.type !== 'status')" :class="{ 'px-2' : table }">
					<label class="os-dirty-label" v-if="!singleLine">
						{{ keyedFields[field.id].name }}<br/>
					</label>
					<field-value
						class="subheading"
						:field="field"
						:value="value"></field-value>

					<div style="clear:both;"></div>
				</div>

				<div @click.stop v-else :class="[(table ? (scopefield.type == 'status' ? 'px-4' : 'px-2') : '' ), { 'os-field-editing-nosave' : viewform && inlineEdit && !inlineSave && editing && scopefield.type !== 'status' }, { 'os-field-editing-save' : viewform && inlineEdit && inlineSave && editing && scopefield.type !== 'status' }]">
			        <template v-if="scopefield.type === 'checkbox'">
			            <v-checkbox
			            	ref="fieldinput"
			                :label="scopefield.name"
			                :required="scopefield.required"
			                :hint="scopefield.configuration.hint_text"
			                :persistent-hint="!!scopefield.configuration.hint_text"
			                :prepend-icon="scopefield.configuration.icon"
			                :rules="[rules.required]"
			                v-model="scopevalue.value"
			                :readonly="scopefield.configuration.read_only"
			                :append-icon="(scopefield.configuration.read_only ? 'lock' : null)">
			        	</v-checkbox>
			        </template>
			        <template v-else-if="scopefield.type === 'date'">
                        <v-menu
							v-if="!scopefield.configuration.current_selection"
			                ref="menu"
                            v-model="datemenu"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            :close-on-content-click="false">

							<template v-slot:activator="{ on }">
								<v-text-field
									v-on="on"
									v-model="scopevalue.value"
									readonly
									ref="fieldinput"
									:clearable="!scopefield.required && !scopefield.configuration.read_only"
									:label="scopefield.name"
									:required="scopefield.required"
									:hint="scopefield.configuration.hint_text"
									:persistent-hint="!!scopefield.configuration.hint_text"
									:prefix="scopefield.configuration.prefix"
									:prepend-icon="scopefield.configuration.icon"
									:suffix="scopefield.configuration.suffix"
									:rules="[rules.required]"
									:single-line="singleLine"
									:append-icon="(scopefield.configuration.read_only ? 'lock' : null)"></v-text-field>
                                	<!-- TODO: :value="valueFormatted" -->
							</template>

                            <v-date-picker v-model="scopevalue.value" no-title scrollable @input="datemenu = false"></v-date-picker>
                        </v-menu>
						<template v-else>
							<v-autocomplete
								ref="fieldinput"
								:search-input.sync="autocompleteSearchText"
								:items="[{
									text: 'Day',
									value: 'day'
								},{
									text: 'Week',
									value: 'week'
								},{
									text: 'Month',
									value: 'month'
								},{
									text: 'Quarter',
									value: 'quarter'
								},{
									text: 'Year',
									value: 'year'
								}]"
								:label="scopefield.name"
								:required="scopefield.required"
								:single-line="singleLine"
								:clearable="!scopefield.required && !scopefield.configuration.read_only"
								:multiple="scopefield.configuration.multiselect"
								:chips="scopefield.configuration.chips"
								:hint="scopefield.configuration.hint_text"
								:persistent-hint="!!scopefield.configuration.hint_text"
								:prepend-icon="scopefield.configuration.icon"
								:rules="[rules.required]"
								:readonly="scopefield.configuration.read_only"
								:append-icon="(scopefield.configuration.read_only ? 'lock' : 'arrow_drop_down')"
								v-model="scopevalue.value"
								item-text="text"
								item-value="value"></v-autocomplete>
						</template>
			        </template>
			        <template v-else-if="scopefield.type === 'select' || scopefield.type === 'posttype'">
			            <v-autocomplete
			            	ref="fieldinput"
							:search-input.sync="autocompleteSearchText"
			                :items="fieldoptions"
			                :label="scopefield.name"
			                :required="scopefield.required"
							:single-line="singleLine"
			                :clearable="!scopefield.required && !scopefield.configuration.read_only"
			                :multiple="scopefield.configuration.multiselect"
			                :chips="scopefield.configuration.chips"
			                :hint="scopefield.configuration.hint_text"
			                :persistent-hint="!!scopefield.configuration.hint_text"
			                :prepend-icon="scopefield.configuration.icon"
			                :rules="[rules.required]"
			                :readonly="scopefield.configuration.read_only"
			                :append-icon="(scopefield.configuration.read_only ? 'lock' : 'arrow_drop_down')"
			                v-model="scopevalue.value"
			                :item-text="(scopefield.type === 'posttype' ? 'name' : 'label')"
			                item-value="id">
								<div slot="no-data"></div>
								<div class="v-list-item v-list-item--link" role="listitem" slot="append-item" v-if="iCan('create', 'Customers') && scopefield.id === customerField.id && autocompleteSearchText && !disableAddOption" @click="createCustomer">
									<a class="v-list__tile v-list__tile--link theme--light">
										<div class="v-list__tile__content">
											<div class="v-list__tile__title">Create as new customer</div>
										</div>
									</a>
								</div>
								<div class="v-list-item v-list-item--link" role="listitem" slot="append-item" v-else-if="scopefield.configuration.allow_custom && autocompleteSearchText" @click="createCustomValue">
									<a class="v-list__tile v-list__tile--link theme--light">
										<div class="v-list__tile__content">
											<div class="v-list__tile__title">Custom value</div>
										</div>
									</a>
								</div>
							</v-autocomplete>
			        </template>
			        <div v-else-if="scopefield.type === 'status'" class="pa-h">
                        <template v-if="!singleLine">
                            <label class="os-dirty-label">{{ scopefield.name }}</label><br/>
                        </template>
                        <v-menu @click.native.stop :disabled="scopefield.configuration.read_only">
                            <template v-slot:activator="{ on }" v-if="keyedLocalOptions && keyedLocalOptions[scopevalue.value] && scopevalue.value">
                    			<v-btn v-on="on" :color="keyedLocalOptions[scopevalue.value].value" :dark="keyedLocalOptions[scopevalue.value].configuration.white_text" class="ma-0" :disabled="scopefield.configuration.read_only">
                                    {{ keyedLocalOptions[scopevalue.value].label }}
                                </v-btn>
                            </template>
							<v-btn v-else-if="scopefield.configuration.read_only" color="white" class="ma-0" disabled>
								Not set
							</v-btn>
							<template v-else v-slot:activator="{ on }">
								<v-btn v-on="on" color="default" class="ma-0" :disabled="scopefield.configuration.read_only">
									Not set
								</v-btn>
							</template>
                            <v-list class="py-0">
                                <v-list-item
                                    v-for="(option, index) in scopefield.fieldoptions"
                                    :key="index"
									:dark="option.configuration.white_text"
                                    :class="option.value"
                                    @click="changeStatus(option.id)">

                                    <v-list-item-title>{{ option.label }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
			        </div>
			        <template v-else-if="scopefield.type === 'file'">
						<v-layout>
							<v-flex xs12 v-if="scopevalue.value && scopevalue.value.url" class="overflow-hidden mt-4" :class="{'mb-4' : singleLine}">
								<v-btn outlined @click.native="imgDialog = true" max-width="100%" height="33px" class="truncate-sub-text">
									{{ scopevalue.value.filename }}
								</v-btn>
								<v-dialog v-model="imgDialog" width="500">
									<v-card>
        								<v-img :src="scopevalue.value.url"></v-img>
									</v-card>
								</v-dialog>
							</v-flex>
							<v-flex v-if="!scopefield.configuration.read_only">
								<v-file-input
									ref="fieldinput"
									:hide-input="(scopevalue.value && !!scopevalue.value.url)"
									:label="scopefield.name"
									:required="scopefield.required"
									:hint="scopefield.configuration.hint_text"
									:persistent-hint="!!scopefield.configuration.hint_text"
									:prepend-icon="scopefield.configuration.icon ? scopefield.configuration.icon : 'mdi-paperclip'"
									:prefix="scopefield.configuration.prefix"
									:suffix="scopefield.configuration.suffix"
									:counter="scopefield.configuration.show_counter"
									:show-size="scopefield.configuration.show_size"
									:chips="scopefield.configuration.chips"
									v-model="scopevalue.value"
									:single-line="singleLine"
									:rules="[rules.required]"
								></v-file-input>
							</v-flex>
						</v-layout>
			        </template>
			        <template v-else-if="scopefield.type === 'integer'">
			            <v-text-field
			            	ref="fieldinput"
			                :label="scopefield.name"
			                :required="scopefield.required"
			                :hint="scopefield.configuration.hint_text"
			                :persistent-hint="!!scopefield.configuration.hint_text"
			                :prepend-icon="scopefield.configuration.icon"
			                :prefix="scopefield.configuration.prefix"
			                :suffix="scopefield.configuration.suffix"
			                :counter="(scopefield.configuration.show_counter) ? scopefield.configuration.max_length : null"
			                v-model.number="scopevalue.value"
							:single-line="singleLine"
			                :readonly="scopefield.configuration.read_only"
			                :rules="[rules.integer, rules.required]"
			                :append-icon="(scopefield.configuration.read_only ? 'lock' : null)"
			            ></v-text-field>
			        </template>
			        <template v-else>
			            <component
			            	:is="(scopefield.type === 'textarea' ? 'v-textarea' : scopefield.type === 'file' ? 'v-file-input' : 'v-text-field')"
			            	ref="fieldinput"
							multiple
			                :label="scopefield.name"
			                :required="scopefield.required"
			                :hint="scopefield.configuration.hint_text"
			                :persistent-hint="!!scopefield.configuration.hint_text"
			                :prepend-icon="scopefield.configuration.icon"
			                :prefix="scopefield.configuration.prefix"
			                :suffix="scopefield.configuration.suffix"
			                :counter="(scopefield.configuration.show_counter) ? scopefield.configuration.max_length : null"
			                v-model="scopevalue.value"
							:single-line="singleLine"
			                :readonly="scopefield.configuration.read_only"
			                :rules="[rules.decimal, rules.email, rules.integer, rules.url, rules.required, rules.max_length]"
			                :append-icon="(scopefield.configuration.read_only ? 'lock' : null)"
			            ></component>
			        </template>
				</div>
			</div>
		</transition>
    </component>
</template>

<script>
	import { mapGetters } from 'vuex';
	import FieldValue from './FieldValue';

    export default {
		components: {
			'field-value' : FieldValue
		},
        computed: {
			...mapGetters([
				'customerField',
                'fieldShortcodes',
		    	'keyedCustomers',
				'keyedFieldOptions',
			    'keyedFields',
				'keyedProducts'
			]),  
			customerField() {
				return (this.type === 'purchase-order') ? this.$store.getters.po_customerField : this.$store.getters.customerField;
			},
			touchdevice() {
				return "ontouchstart" in document.documentElement;
			},
            baseField() {
                let field = _.cloneDeep(this.field);
                if(this.overrideBase){
                    for (var property in this.overrideBase) {
                        if (this.overrideBase.hasOwnProperty(property)) {
                            field[property] = this.overrideBase[property];
                        }
                    }
                }
                if(this.overrideConfig){
                    for (var property in this.overrideConfig) {
                        if (this.overrideConfig.hasOwnProperty(property)) {
                            field.configuration[property] = this.overrideConfig[property];
                        }
                    }
                }
                return field;
            },
			fieldassignments () {
				let assignments = [];
				if(this.keyedFieldvalues && this.availableassignments){
					assignments = this.availableassignments.filter(assignment => {
						let matched = false;
						for(let x = 0, group; group = assignment.conditiongroups[x]; x++){
							let count = group.conditions.length,
								matches = 0;
							for(let y = 0, condition; condition = group.conditions[y]; y++){
								let valueobj = this.keyedFieldvalues[condition.field_id];

								if(valueobj){

									if(valueobj.orderitem && this.rowindex > -1){
										valueobj = [valueobj[this.rowindex]];
									}else if(valueobj.orderitem){
										valueobj = Object.values(valueobj);
									}else{
										valueobj = [valueobj];
									}

									for(let z = 0, value; value = valueobj[z]; z++){
										let matched2 = false;

										if(condition.comparator === 'before'){
											if(new Date(value.value) <= new Date(condition.value))
												matched2 = true;
										}else if(condition.comparator === 'after'){
											if(new Date(value.value) >= new Date(condition.value))
												matched2 = true;
										}else if(condition.comparator === '>'){
											if(parseFloat(value.value) > parseFloat(condition.value))
												matched2 = true;
										}else if(condition.comparator === '<'){
											if(parseFloat(value.value) < parseFloat(condition.value))
												matched2 = true;
										}else if(condition.comparator === '='){
											if(
												condition.value === value.value ||
												(
													value.format === 'array' &&
													value.value.indexOf(condition.value) > -1
												)
											){
												matched2 = true;
											}
										}else if(condition.comparator === '!='){
											if(
												condition.value !== value.value ||
												(
													value.format === 'array' &&
													value.value.indexOf(condition.value) === -1
												)
											){
												matched2 = true;
											}
										}else if(condition.comparator === 'IN'){
											if(value.format !== 'array'){
												if(condition.value.indexOf(value.value) > -1){
													matched2 = true;
												}
											}else{
												for(let w = 0, itemvalue; itemvalue = value.value[w]; w++){
													if(condition.value.indexOf(itemvalue) > -1){
														matched2 = true;
														break;
													}
												}
											}
										}else if(condition.comparator === 'contains'){
											if(typeof value.value === 'string' && value.value.includes(condition.value)){
												matched2 = true;
											}
										}

										if(matched2){
											matches++;
											break;
										}
									}
								}
								if(count === matches){
									matched = true;
									break;
								}
							}
						}
						return matched;
					});
				}
				return assignments;
			},
            fieldoptions () {
				let options = [];
                if(this.field.configuration.option_groups_boolean){
                    let groups = {};
					for(let x = 0, option; option = this.field.fieldoptions[x]; x++){
						if(!option.deleted_at && option.id && (!this.filteredoptions.length || this.filteredoptions.indexOf(option.id) > -1)){
                            if(option.configuration.option_group){
                                if(!groups[option.configuration.option_group])
                                    groups[option.configuration.option_group] = [];
                                groups[option.configuration.option_group].push(option);
                            }else{
                                options.push(option);
                            }
                        }
                    };
                    for(let group in groups){
                        if (groups.hasOwnProperty(group)) {
                            options.push({ header: group });
                            groups[group].forEach(option => {
                                options.push(option);
                            });
                        }
                    }
                }else{
                    let fieldoptions = this.field.fieldoptions,
						assignment_type = (this.field.assignment_type === 'purchase-order' || this.field.assignment_type === 'purchase-orderitem') ? 'purchase-order' : 'order';
					if(this.field.internal_name === 'product')
                        fieldoptions = this.$store.state.products.filter(product => product.assignment_type === assignment_type);
					if(this.field.internal_name === 'customer')
						fieldoptions = this.$store.state.customers.filter(customer => customer.assignment_type === assignment_type);
						if(this.newCustomerOption)
							fieldoptions = fieldoptions.concat([this.newCustomerOption]);
                    if(this.field.internal_name === 'price_type')
                        fieldoptions = this.$store.state.pricetypes.filter(product => product.assignment_type === assignment_type);
					if(this.field.type === 'posttype')
                        fieldoptions = (this.field.configuration.posttype ? this.$store.state.posttype_items.filter(item => item.posttype_id == this.field.configuration.posttype) : []);
					for(let x = 0, option; option = fieldoptions[x]; x++){
						if(!option.deleted_at && option.id && (!this.filteredoptions.length || this.filteredoptions.indexOf(option.id) > -1)){
                            if(['product', 'customer', 'price_type'].indexOf(this.field.internal_name) > -1)
                                option.label = option.name;
                            options.push(option);
                        }
                    }
                }
				if(this.newCustomOption)
					options = options.concat([this.newCustomOption]);

                return options;
            },
            generatedValue () {
				let value = null,
					format = this.scopefield.configuration.format;
				if(this.scopefield.type === 'generated' && !!format && (!this.scopefield.configuration.generate_new_only || !this.viewform) && this.keyedFieldvalues){
					let selectors = format.match(/\[(.*?)(?=\s|\])(.*?)](.*?\[\/\1])?/g);

					for(let i = 0, selector; selector = selectors[i]; i++){
						let internalname = selector.replace('[', '').replace(']', ''),
							replacementparts = [],
							property = null;

						if(internalname && internalname.includes('.')){
							let nameparts = internalname.split('.');
							internalname = nameparts[0];
							property = nameparts[1]
						}

						let shortcode = this.fieldShortcodes[internalname],
							fieldid = shortcode.id,
							value2 = this.keyedFieldvalues[fieldid];

						if(fieldid && value2){
							if(value2.orderitem && this.rowindex > -1){
								value2 = [this.keyedFieldvalues[fieldid][this.rowindex]];
							}else if(value2.orderitem){
								value2 = Object.values(this.keyedFieldvalues[fieldid]);
							}else{
								value2 = [value2];
							}

							for(let j = 0, val; val = value2[j]; j++){
								let replacement = false;

								if(val.value){
									if(shortcode.type === 'select'){
										if(internalname === 'product'){
											if(['id', 'label'].indexOf(property) > -1){
												replacement = this.keyedProducts[val.value][property];
											}else{
												replacement = this.keyedProducts[val.value].name;
											}
										}else if(internalname === 'customer') {
											if(property === 'id'){
												replacement = this.keyedCustomers[val.value][property];
											}else{
												replacement = this.keyedCustomers[val.value].name;
											}
										}else{
											if(!this.keyedFieldOptions[val.value] || this.keyedFieldOptions[val.value].field_id !== shortcode.id){
												replacement = val.value;
											}else if(['id', 'label'].indexOf(property) > -1){
												replacement = this.keyedFieldOptions[val.value][property];
											}else{
												replacement = this.keyedFieldOptions[val.value].value;
											}
										}
										replacement = '"' + replacement + ' "';
									}else{
										if(['decimal', 'integer'].indexOf(shortcode.type) > -1){
											replacement = val.value;
										}else{
											replacement = '"' + val.value + ' "';
										}
									}
								}
								if(replacement){
									replacementparts.push(replacement);
								}
							}
						}

						if(!replacementparts.length)
							replacementparts = ['""'];

						format = format.replace(selector, replacementparts.join('+'));
					}
				}
				if(format){
					let val = null;
					try {
						val = eval(format);
					} catch (e) {}
					if(val)
						value = val;
				}

				if(value)
					value = value+'';
				return value;
			},
            keyedLocalOptions() {
                let options = {};
                for(let x = 0, option; option = this.scopefield.fieldoptions[x]; x++){
                    let option = this.scopefield.fieldoptions[x];
                    options[option.id] = option;
                }
                return options;
            },
            rules() {
                let rules = {
                    decimal: (value) => {
                        if(this.baseField.type != 'decimal' || !value)
                            return true;
                        const pattern = /^[0-9]+(\.[0-9]{1,4})?$/;
                        return pattern.test(value) || 'Invalid decimal.';
                    },
                    email: (value) => {
                        if(this.baseField.type != 'email' || !value)
                            return true;
                        const pattern = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/
                        return pattern.test(value) || 'Invalid e-mail.'
                    },
                    integer: (value) => {
                        if(this.baseField.type != 'int' || !value)
                            return true;
                        const pattern = /^\d+$/;
                        return pattern.test(value) || 'Invalid number.';
                    },
                    max_length: (value) => {
                        if(!this.baseField.configuration.max_length || !value)
                            return true;

                        return (this.baseField.configuration.max_length >= value.length) || 'Too many characters.';
                    },
                    url: (value) => {
                        if(this.baseField.type != 'url' || !value)
                            return true;
                        const pattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
                        return pattern.test(value) || 'Invalid URL.';
                    },
                    required: (value) => (!this.baseField.required || ((!!value || value === 0) && (!Array.isArray(value) || value.length > 0))) || this.baseField.name+' is required.'
                }
                return rules;
			},
            valueFormatted () {
                let date = '';
                if(this.field.type === 'date' && !!this.scopevalue.value)
                    date = moment(this.scopevalue.value).format('DD/MM/YYYY');

                return date;
            },
			visible () {
                return (!this.viewform && this.baseField.configuration.hide_new_order) ? false : this.baseField.configuration.visibility === 'hidden' ? false : (this.baseField.configuration.visibility === 'visible' ? true : this.visibilityAssignment ? true : false);
			},
			visibilityAssignment () {
				return this.fieldassignments.filter(assignment => {
					let matched = false;
					for(let x = 0, actionobj; actionobj = assignment.actions[x]; x++){
						if(actionobj.action === 'visibility'){
							matched = true;
							break;
						}
					}
					return matched;
				})[0];
			}
        },
		created () {
            if(this.value)
				this.cachevalue = _.cloneDeep(this.value);
				
			this.checkAssignments({ onLoad: true });
		},
        data() {
            return {
                cachevalue: {},
                datemenu: false,
				editing: (!(this.overrideConfig && this.overrideConfig.read_only) && !this.field.configuration.read_only && (!this.viewform || (this.inlineEdit && !this.value.id) || this.edit) ? true : false),
				filteredoptions: [],
				imgDialog: false,
				autocompleteSearchText: '',
				scopefield: _.cloneDeep(this.field),
                scopevalue: this.value ? _.cloneDeep(this.value) : {
                    value: (this.field.configuration.multiselect && this.field.type === 'select' ? [] : null)
                },
				wrapperTag: (this.table ? 'td' : 'v-flex'),
				newCustomerOption: null,
				newCustomOption: null
            }
        },
        methods: {
			cancelEdit() {
				this.checkFormat({
					val: _.cloneDeep(this.value)
				});
				this.editing = false;
			},
            changeStatus(value) {
                this.scopevalue.value = value;
                if(this.assignment_id)
                    this.saveEdit();
			},
			checkAssignments({ assignments = this.fieldassignments, onLoad = false }) {
				let value = null;
				for(let x = 0, assignment; assignment = assignments[x]; x++){
					for(let y = 0, actionobj; actionobj = assignment.actions[y]; y++){
						if(actionobj.field_id === this.field.id && actionobj.action !== 'visibility'){
							value = _.cloneDeep(actionobj.value);
							break;
						}
					}
				}

                if(!(onLoad && this.viewform)){
    				if(value){
    					if(this.field.type === 'select'){
    						this.filteredoptions = [];
    						if(value.length === 1 && !this.field.configuration.multiselect){
    							if(this.scopevalue.value !== value[0])
    								this.scopevalue.value = value[0];
    							this.scopefield.configuration.read_only = true;
    						}else if(value.length === 1){
    							if(this.scopevalue.value !== value)
    								this.scopevalue.value = value;
    							this.scopefield.configuration.read_only = true;
    						}else{
    							this.filteredoptions = value;
    							if(this.filteredoptions.indexOf(this.scopevalue.value) === -1 && this.scopevalue.value && this.scopevalue.value.length > 0)
    								this.scopevalue.value = (this.field.configuration.multiselect ? [] : null);
    						}
    					}else{
    						this.scopevalue.value = value;
    						this.scopefield.configuration.read_only = true;
    					}
    				}else{
    					if(
                            !this.visible &&
                            this.scopevalue.value &&
                            this.scopevalue.value.length > 0 &&
                            this.scopevalue.value !== this.baseField.configuration.default &&
                            !this.generatedValue
                        ){
    						this.scopevalue.value = (this.field.configuration.multiselect ? [] : null);
    					}
    					this.filteredoptions = [];
                        this.scopefield.configuration.read_only = this.baseField.configuration.read_only;
    				}
                }
			},
            checkFormat(obj = {}) {
				let val = obj.val ? obj.val : _.cloneDeep(this.scopevalue),
					field = (obj.field ? obj.field : _.cloneDeep(this.baseField)),
					delay = false;
				val.format = null;
                switch(field.type){
                    case 'select':
                        if(field.configuration.multiselect){
                            val.format = 'array';
                            if(!Array.isArray(val.value)){
                                val.value = [];
        					    delay = true;
                            }
                        }
                        break;
                    case 'date':
                        if(!/^[0-9]{4}-(((0[13578]|(10|12))-(0[1-9]|[1-2][0-9]|3[0-1]))|(02-(0[1-9]|[1-2][0-9]))|((0[469]|11)-(0[1-9]|[1-2][0-9]|30)))$/.test(val.value))
                            val.value = '';
                        break;
                    case 'integer':
                        val.format = 'integer';
                        break;
                    case 'decimal':
                        val.format = 'float';
						break;
					case 'file':
                        if(field.configuration.multiselect){
                            val.format = 'array';
                            if(!Array.isArray(val.value)) val.value = [];
                        }else{
                            val.format = 'object';
							if(!val.value || Array.isArray(val.value)) val.value = null;
						}
						break;
					case 'generated':
						if(field.configuration.cast !== 'string'){
							val.format = field.configuration.cast;
						}
						break
                }

                if((field.type != 'select' || !field.configuration.multiselect) && (Array.isArray(val.value)) && field.type != 'file'){
                    val.value = '';
				}

				if(field.configuration.default && obj.setdefault && this.setDefault && (!val.value || !val.value.length))
					val.value = field.configuration.default;

				if(!_.isEqual(val, this.scopevalue))
					this.scopevalue = val;

				if(val.value && field.type === 'select' && ['customer', 'product', 'price_type'].indexOf(field.internal_name) === -1){
					let optionindex = _.findIndex(this.fieldoptions, ['id', val.value]);
					if(optionindex === -1){
						this.newCustomOption = {
							id: val.value,
							label: val.value,
							value: val.value,
						}
					}
				}

				if(obj.field){
					if(delay){
						setTimeout(() => {
							this.scopefield = field;
						}, 1)
					}else{
						this.scopefield = field;
					}
				}
			},
			createCustomer() {
				this.newCustomerOption = {
					id: this.autocompleteSearchText,
					name: this.autocompleteSearchText
				}
				this.scopevalue.value = this.autocompleteSearchText;
				this.$refs.fieldinput.blur();
			},
			createCustomValue() {
				this.newCustomOption = {
					id: this.autocompleteSearchText,
					label: this.autocompleteSearchText,
					value: this.autocompleteSearchText
				}
				this.scopevalue.value = this.autocompleteSearchText;
				this.$refs.fieldinput.blur();
			},
			saveEdit() {
				if(!this.$refs.fieldinput || this.$refs.fieldinput.validate()){
					if(_.isEqual(this.value, this.scopevalue)){
						this.editing = false;
					}else{
						this.$store.dispatch('set', { name: 'processing', value: true });

						let data = new FormData(),
							value = _.cloneDeep(this.scopevalue);
                        if(value.value && typeof value.value === 'object' && typeof value.value.name === 'string'){
							data.append('files', value.value);
							value.value = value.value.name;
						}else if(typeof value.value === 'undefined'){
							value.value = null
						}
						let assignment_type = (this.assignment_type === 'purchase-order' ? 'order' : (this.assignment_type === 'purchase-orderitem' ? 'orderitem' : this.assignment_type));
						data.append('assignment_id', this.assignment_id);
						data.append('assignment_type', assignment_type);
						data.append('value', JSON.stringify(value));
						if(this.column)
							data.append('column', this.column);
							
						axios.post('/api/fieldvalue', data)
	                    .then(
	                        response => {
								this.$emit('inputChanged', response.data.fieldvalue);
								this.editing = false;
								this.$store.dispatch('setSnack', { state: 'success', text: response.data.message });
								if(response.data.log && response.data.log.order_id)
									this.$store.dispatch('addOrderLog', { id: response.data.log.order_id, log: response.data.log })
	                        }
	                    )
	                    .catch(e => {
							this.$store.dispatch('setSnack', { state: 'error', text: 'Unable to save value' });
	                    }).then(() => {
    						this.$store.dispatch('set', { name: 'processing', value: false });
    					});
					}
				}
			}
        },
        props: [
			'assignment_id',
			'assignment_type',
			'availableassignments',
			'column',
			'disableAddOption',
			'edit',
			'editDisabled',
            'field',
			'inlineEdit',
			'inlineSave',
			'keyedFieldvalues',
            'overrideBase',
            'overrideConfig',
			'rowindex',
			'setDefault',
			'singleLine',
			'table',
            'value',
			'viewform'
        ],
        watch: {
			edit: function(val) {
				if(this.editing !== val)
					this.editing = val;
			},
			generatedValue: {
				handler: function (value, oldval){
                    if(typeof oldval !== 'undefined' || !this.assignment_id){
    					if(
    						this.scopefield.type === 'generated' &&
    						value !== false &&
    						value !== this.scopevalue.value &&
    						!_.isEqual(value, oldval)
    					){
    						this.scopevalue.value = value;
    					}
                    }
				},
				deep: true,
                immediate: true
			},
            baseField: {
                handler: function (field){
                    this.checkFormat({
    					field: _.cloneDeep(field),
    					setdefault: true
    				});
                },
                deep: true,
                immediate: true
            },
			fieldassignments: {
				handler: function(assignments, oldassignments) {
					if(!_.isEqual(assignments, oldassignments))
						this.checkAssignments({ assignments });
				},
				deep: true
			},
            scopevalue: {
                handler: function (val, oldval) {
					if(!_.isEqual(val, this.value)){
						if(this.viewform && this.inlineEdit){
							if(!this.editing)
								this.editing = true;
						}else{
							this.$emit('inputChanged', val, this.rowindex);
						}
					}
                },
                deep: true,
				immediate: true
            },
      	    value: {
                handler: function(val) {
                    if(!_.isEqual(val, this.cachevalue)){
                        this.cachevalue = _.cloneDeep(val);

    					if(!_.isEqual(val, this.scopevalue)){
    	                    this.checkFormat({
    							val: _.cloneDeep(val)
    						});
    					}
                    }
                },
                deep: true
            }
        }
    }
</script>


<style scoped lang="scss">
	.subheading{
		padding:6px 0;
		display:block;
	}
	.os-action-btns{
		position:absolute;
		right:0;
		// width: 76px;
		top:50%;
		transform:translateY(-50%);
	}

	.os-hover-btn:not(.os-touch-device){
		display:none;
	}

	.os-field-container{
		max-width:100%;
		position:relative;
		overflow:hidden;
		min-height:36px;

		&:hover .os-hover-btn:not(.os-touch-device){
			display: block;
		}

		.os-field-editing-save{
			padding-right: 84px !important;
		}
		.os-field-editing-nosave{
			padding-right: 42px !important;
		}
	}
	.v-enter-active, .v-leave-active {
	  transition: max-width .5s linear;
	}
	.v-enter, .v-leave-to /* .fade-leave-active below version 2.1.8 */ {
	  max-width: 0;
	}
</style>

<style>
	.os-readonly-field .input-group__append-icon{
		font-size:18px;
	}
	.truncate-sub-text > span{
		display:block;
		max-width:100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>
